import { useRef, useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { CSVLink } from 'react-csv';
import useRequestLocation from './useRequestLocation';
import moment from 'moment';
import formatEventName from '../services/MeTicketAdditional/FormatEventName';
import { useTranslation } from 'react-i18next';

const useMeTicketCsvDownload = () => {
  const { t } = useTranslation();
  const filters = useSelector((state) => state.filters);
  const { getEventsFilters } = useRequestLocation();
  const ref = useRef(null);
  const [csvData, setCsvData] = useState([]);

  const headers = [
    { label: 'Date', key: 'date' },
    { label: 'Event', key: 'event' },
    { label: 'Sales', key: 'sales' },
    { label: 'Views', key: 'views' },
  ];

  useEffect(() => {
    if (csvData.length) {
      ref.current.link.click();
      setCsvData([]);
    }
  }, [csvData]);

  const downloadCsv = async () => {
    const data = await getEventsFilters(
      filters.periodStart,
      filters.periodEnd,
      filters.eventsArray
    );
    if (!data?.salesAndViewsDiagrams) return;

    const { salesAndViewsDiagrams, events, eventMeta, tickets } = data;
    const eventNames = events || tickets || {};
    const rows = [];

    Object.entries(salesAndViewsDiagrams).forEach(([eventId, dateData]) => {
      const rawEventName = eventNames[eventId] || eventId;
      const eventName = events
        ? formatEventName(
          rawEventName,
          eventId,
          eventMeta,
          t('ticketStatistic.archive')
        )
        : rawEventName;
      Object.entries(dateData).forEach(([dateStr, values]) => {
        if (dateStr === 'null') return;
        rows.push({
          date: moment(dateStr).format('YYYY-MM-DD'),
          event: eventName,
          sales: values.sales ?? 0,
          views: values.views ?? 0,
        });
      });
    });

    rows.sort((a, b) => a.date.localeCompare(b.date));
    setCsvData(rows);
  };

  const CsvLinkHidden = () => (
    <CSVLink
      ref={ref}
      data={csvData}
      headers={headers}
      filename="ticket-statistics.csv"
      style={{ display: 'none' }}
    />
  );

  return { downloadCsv, CsvLinkHidden };
};

export default useMeTicketCsvDownload;
